import LandingHero from "./USA-Components/LandingHero";
import PeopleConnect from "./USA-Components/PeopleConnect";
import SmarterSupport from "./USA-Components/SmarterSupport";
import Experience from "./USA-Components/Experience";
import ClearValue from "./USA-Components/ClearValue";
import GlobalExpertise from "./USA-Components/GlobalExpertise";
import Blog from "./USA-Components/Blog";
import UsaLayout from "./layout/USALayout";
const Usa = () => {
  return (
    <UsaLayout>
        <LandingHero />
        <PeopleConnect />
        <SmarterSupport />
        <Experience />
        <ClearValue />
        <GlobalExpertise />
        <Blog />
    </UsaLayout>
  )
};
export default Usa;